import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { PagedContactTypeResponse, SearchContactTypeModel } from '../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { ServiceOrderService } from '../../core/services/service/service-order/service-order.service'
import { ContractCreateComponent } from '../../features/contract/contract-create/contract-create.component'
import { convertCurrency } from '../../shared/utils/utils'
import { ProposalClientService } from '../../core/services/proposal/proposal-client/proposal-client.service'
import { ContractClientService } from '../../core/services/contract/contract-client/contract-client.service'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { TableListContractComponent } from '../../shared/components/table-list-contract/table-list-contract.component'
import { ModalCancelContractComponent } from '../../features/contract/modal-cancel-proposal/modal-cancel-contract.component'
import { SearchLogisticsComponent } from './search-logistics/search-logistics.component'
import { ModalLogisticsComponent } from '../../features/logistics/modal-logistics/modal-logistics.component'
import { SnackbarCustomService } from '../../shared/components/snackbar/snackbar-custom.service'
import { StatusVooConfiguracaoService } from '../../core/services/status-voo/status-voo-configuracao.service'
import { DialogConfirmComponent } from '../../shared/components/dialog-confirm/dialog-confirm.component'

@Component({
  selector: 'logistics',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatPaginator,
    SearchLogisticsComponent,
    TableListContractComponent,
  ],
  templateUrl: './logistics.component.html',
  styleUrl: './logistics.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class LogisticsComponent implements OnInit {
  constructor(
    private proposalClientService: ProposalClientService,
    private contractClientService: ContractClientService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
    private statusVooConfiguracaoService: StatusVooConfiguracaoService,
  ) {
    this.user = this.authService.getInfosObject()
  }

  private pollingInterval: ReturnType<typeof setInterval> | null = null
  private lastConfig: { intervaloAtualizacaoMinutos: number; ativo: boolean } | null = null

  user: any = {}
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch = ''
  spinLoad = {
    contract: false, email: false, download: false, edit: false,
    manager: false, view: false, remove: false,
    cancelContract: false, approveContract: false, refuseContract: false,
  }

  columns: any[] = [
    {
      keyColumn: 'event_tg',
      key: 'codigoTg',
      description: 'Evento',
    },
    {
      keyColumn: 'contract_client',
      key: 'nomeCliente',
      description: 'Cliente',
    },
    {
      keyColumn: 'contract_consult',
      key: 'nomeConsultorOperacional',
      description: 'Consultor',
    },
    {
      keyColumn: 'contract_period',
      key: 'dataInicio',
      description: 'Período',
    },
    {
      keyColumn: 'status',
      key: 'statusDescricao',
      description: 'Status',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, view: true, cancelContract: false },
      description: 'Ações',
    },
  ]
  screen = 'contrato cliente'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        // edit: this.checkPermission('editar'),
        // delete: this.checkPermission('deletar'),
        // view: true,
        // cancelContract: this.checkPermission('cancelar contrato'),
        // this.user.idPerfil &&
        // (this.user.idPerfil == 1 ||
        //   this.user.idPerfil == 2 ||
        //   this.user.idPerfil == 3)
        //   ? true
        //   : false,
        view: true,
        approveContract: true,
        refuseContract: true,
        sendEmailOrcamento: true,
        download: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    this.loading = true
    this.contractClientService.searchPagedContractClient(this.page, this.rows, event).subscribe({
      next: (res) => {
        this.loading = false
        if (res.data === null) {
          this.numberRows = 0
        } else {
          this.numberRows = res.data.totalItens
        }

        this.treatResponse(res)
      },
      error: (err: any) => {
        this.loading = false
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      // this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        // Verifica se o status da proposta é 'Pendente'

        list.push({
          ...item,
          valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        })

        // if (item.statusPropostaDescricao === 'Pendente'){

        //   list.push({
        //     ...item,
        //     valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        //   })
        // }
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.contractClientService.listPagedContractClient(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  // searchListItems() {
  //   this.loading = true
  //   this.contractClientService
  //     .searchPagedContractClient(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => { },
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  newPriceQuote() {
    const dialogRef = this.dialog.open(ContractCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ModalLogisticsComponent, {
      data: { item },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  approveContract(item: any) {
    this.contractClientService.approveContract(item.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadList()
      },
      error: (err: any) => {
        this.snackbar.errorRequest(err)
      },
    })
  }

  refuseContract(item: any) {
    this.contractClientService.refuseContract(item.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadList()
      },
      error: (err: any) => {
        this.snackbar.errorRequest(err)
      },
    })
  }
  downloadPdf(item: any): void {
    this.spinLoad.download = true
    this.contractClientService.getLogisticaPdf(item.id).subscribe({
      next: (response) => {
        const blob = response.body!
        const contentDisposition = response.headers.get('Content-Disposition')
        let fileName = `GL - LOGISTICA - ${item.id}.xlsx`
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (match?.[1]) fileName = decodeURIComponent(match[1].replace(/['"]/g, ''))
        }
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        this.spinLoad.download = false
      },
      error: (err: any) => {
        this.snackbar.errorRequest(err)
        this.spinLoad.download = false
      },
    })
  }

  sendEmailCliente(item: any): void {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '400px',
      width: '400px',
      data: {
        title: 'Enviar E-mail de Logística',
        message: 'Deseja realmente enviar o e-mail de logística para o cliente?',
        confirmLabel: 'Enviar',
      },
    })

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return
      this.spinLoad.email = true
      this.contractClientService.sendEmailLogistica(item.id).subscribe({
        next: (res: any) => {
          this.spinLoad.email = false
          this.snackbar.success(res.message ?? 'E-mail enviado com sucesso.')
        },
        error: (err: any) => {
          this.spinLoad.email = false
          this.snackbar.errorRequest(err)
        },
      })
    })
  }
  cancelContract(item: any) {
    const dialogRef = this.dialog.open(ModalCancelContractComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '90vw',
      width: '100%',
      maxHeight: '90vh',
      data: { item: item },
    })
    dialogRef.componentInstance.responseDelete.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
    /*
    const dialogRef = this.dialog.open(DialogChooseComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: 'Deseja realmente cancelar o contrato? Todas as OS gerados a partir desse contrato serão cancelados.',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.contractClientService.cancelContract(item.id).subscribe({
          next: (response: any) => {
            this.uploadList()
          },
          error: (err: PagedContactTypeResponse) => {},
          complete: () => {
            this.loading = false
          },
        })
      }
    })
    */
  }

  cancelProposal(proposalId: any) {
    //   this.proposalService.cancelProposal(proposalId).subscribe({
    //     next: (response: any) => {
    //       this.uploadList()
    //     },
    //     error: (err: PagedContactTypeResponse) => {},
    //     complete: () => {
    //       this.loading = false
    //     },
    //   })
  }

  // downloadItem(item: any) {
  //   this.contractClientService.downloadContractClient(item.id).subscribe({
  //     next: (response: any) => {
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => { },
  //   })
  // }

  deleteItem(item: any) {}
}
